var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconAudioComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Audio ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: useCurrentColor ? 'currentColor' : '#F6BA1E'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2502 7.6403H11.9502H25.9005H27.6005V9.3403V23.1416H27.5905C27.5972 23.2352 27.6006 23.3298 27.6006 23.4252C27.6006 25.595 25.8416 27.3541 23.6717 27.3541C21.5018 27.3541 19.7428 25.595 19.7428 23.4252C19.7428 21.2553 21.5018 19.4963 23.6717 19.4963C23.851 19.4963 24.0275 19.5083 24.2005 19.5316V11.0403H13.6502V25.0902H13.6429C13.6438 25.123 13.6442 25.1559 13.6442 25.1889C13.6442 27.3588 11.8851 29.1178 9.71527 29.1178C7.5454 29.1178 5.78638 27.3588 5.78638 25.1889C5.78638 23.0191 7.5454 21.26 9.71527 21.26C9.89673 21.26 10.0753 21.2723 10.2502 21.2961V9.3403V7.6403Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconAudio = /*#__PURE__*/React.forwardRef(IconAudioComponent);
export default IconAudio;